import Vue from "vue";

const Maintenance = {
  namespaced: true,
  state: {
    status: {
      active: false,
      current_window: null,
    },
    windows: [],
  },
  mutations: {
    SET_STATUS(state, payload) {
      state.status = payload || { active: false, current_window: null };
    },
    SET_WINDOWS(state, list) {
      state.windows = Array.isArray(list) ? list : [];
    },
  },
  actions: {
    fetchStatus({ commit }) {
      return Vue.axios
        .get(window.urlapi + "maintenance/status")
        .then((response) => {
          const body = response.data;
          if (body && body.success && body.data) {
            commit("SET_STATUS", body.data);
          }
          return response.data;
        });
    },
    fetchWindows({ commit }) {
      return Vue.axios
        .get(window.urlapi + "maintenance/windows")
        .then((response) => {
          const body = response.data;
          if (body && body.success && body.data !== undefined && body.data !== null) {
            commit("SET_WINDOWS", body.data);
          }
          return response.data;
        });
    },
    createWindow(context, { starts_at, ends_at }) {
      return Vue.axios.post(window.urlapi + "maintenance/windows", {
        starts_at,
        ends_at,
      });
    },
    endWindowNow(context, id) {
      return Vue.axios.patch(
        window.urlapi + "maintenance/windows/" + id,
        { action: "end_now" }
      );
    },
    extendWindow(context, { id, ends_at }) {
      return Vue.axios.patch(
        window.urlapi + "maintenance/windows/" + id,
        { ends_at }
      );
    },
    cancelFutureWindow(context, id) {
      return Vue.axios.delete(
        window.urlapi + "maintenance/windows/" + id
      );
    },
  },
  getters: {
    maintenanceActive: (state) => state.status && state.status.active,
    windows: (state) => state.windows,
  },
};

export default Maintenance;
